import { isExpEditor } from '../lib/lib'
import 'jquery-ui'
import Swiper from 'swiper/bundle'
//import { Navigation, Pagination } from 'swiper/modules';
import constants from '../lib/constants'

//import 'swiper/css';

class moviesPreview {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.wrap = jQuery(element)

    document.addEventListener('on-youtube-iframe-api-ready', () => {
      // do something
    })

    const swiper = new Swiper(this.wrap.find('.swiper')[0], {
      // modules: [Navigation, Pagination],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>'
        },
      },
    })
  }
}
export default moviesPreview
